import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ScrollDialog = ({
    show,
    title = "",
    content = "",
    cancelLabel = "Close",
    onClose = () => { },
    scroll="paper"
}) => {

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    React.useEffect(() => {
        setOpen(show);
    }, [show])

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                PaperProps={{sx:{borderRadius:3}}}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="scroll-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{cancelLabel}</Button>
                </DialogActions>
            </Dialog>
        </ >
    );
}


export default ScrollDialog;